// @flow
/** API may return camelCase or PascalCase (.NET default JSON). */
function pickOrderList(data: any): any[] {
    if (data == null || typeof data !== 'object') return [];
    const list = data.objOrderList ?? data.ObjOrderList;
    return Array.isArray(list) ? list : [];
}

function pickPaidList(data: any): any[] {
    if (data == null || typeof data !== 'object') return [];
    const list =
        data.maintenencePaidList ??
        data.MaintenancePaidList ??
        data.maintenancePaidList;
    return Array.isArray(list) ? list : [];
}

const initialState = {
    maintenancePaid:0,
    remainingPoints:0,
    totalReward:0,
    availablePoints:0,
    availableRewardList:[],
    expiredRewardList:[],
    rewardList:[],
    isLoading:true,
    qrCode : "",
    redeemCode:"",
    data:{},
    uid:"",
    /** UserKey from GetRewardDetail — use for list POSTs (often a GUID, not query uid) */
    rewardListUserKey: "",
    paidList:[],
};

export default function reward(state= initialState, action:any) {
    switch (action.type) {
        case 'GET_REWARD_DETAIL_PENDING':
            return {...state,isLoading:true};
        case 'GET_REWARD_DETAIL_FULFILLED': {
            const d = action?.payload?.data ?? {};
            const listKey = d.UserKey ?? d.userKey ?? "";
            return {
                ...state,
                maintenancePaid: d.MaintenancePaid ?? d.maintenancePaid ?? state.maintenancePaid,
                remainingPoints: d.RemainingPoints ?? d.remainingPoints ?? state.remainingPoints,
                availablePoints: d.AvailablePoints ?? d.availablePoints ?? state.availablePoints,
                totalReward: d.TotalReward ?? d.totalReward ?? state.totalReward,
                rewardListUserKey: listKey ? String(listKey) : state.rewardListUserKey,
                isLoading: false,
            };
        }
        case 'GET_REWARD_DETAIL_REJECTED':
            return {...state,isLoading:false}; 
        case 'GET_REWARD_INSIDE_LIST_PENDING':
            return {...state,isLoading:true,};
        case 'GET_REWARD_INSIDE_LIST_FULFILLED':
            return {
                ...state,
                availableRewardList: pickOrderList(action?.payload?.data),
                isLoading:false,
            };
        case 'GET_REWARD_INSIDE_LIST_REJECTED':
            return {...state,isLoading:false}; 
        case 'GET_REWARD_EXPIRED_LIST_PENDING':
            return {...state,isLoading:true,};
        case 'GET_REWARD_EXPIRED_LIST_FULFILLED':
            return {
                ...state,
                expiredRewardList: pickOrderList(action?.payload?.data),
                isLoading:false,
            };
        case 'GET_REDEEM_CODE_REJECTED':
            return {...state,isLoading:false}; 
        case 'GET_REDEEM_CODE_PENDING':
            return {...state,isLoading:true,};
        case 'GET_REDEEM_CODE_FULFILLED':
            return {...state,redeemCode:action.payload.data,isLoading:false};
        case 'SUBMIT_REDEEM_CODE_REJECTED':
            return {...state,isLoading:false}; 
        case 'SUBMIT_REDEEM_CODE_PENDING':
            return {...state,isLoading:true,};
        case 'SUBMIT_REDEEM_CODE_FULFILLED':
            return {...state,redeemCode:action.payload.data,isLoading:false};
        case 'GET_REWARD_LIST_PENDING':
            return {...state,isLoading:true,};
        case 'GET_REWARD_LIST_FULFILLED':
            return {...state,rewardList: pickOrderList(action?.payload?.data),isLoading:false,
            };
        case 'GET_PAID_LIST_REJECTED':
            return {...state,isLoading:false}; 
        case 'GET_PAID_LIST_PENDING':
            return {...state,isLoading:true,};
        case 'GET_PAID_LIST_FULFILLED':
            return {
                ...state,
                paidList: pickPaidList(action?.payload?.data),
                isLoading:false,
            };
        case 'GET_REWARD_LIST_REJECTED':
            return {...state,isLoading:false}; 
        case 'GET_QR_CODE':
            return {...state,qrCode:action.qrCode,data:action.item,uid:action.uid}; 
        // case 'SHOW_HIDE_REWARD_DETAIL':
        //     var availableRewards = JSON.parse(JSON.stringify(state.availableRewards ));
        //     availableRewards[action.index].hideDetail = !availableRewards[action.index].hideDetail
        //     return {...state, availableRewards,expiredRewardList:availableRewards};
        // case 'SHOW_HIDE_EXPIRED_DETAIL':
        //     var expiredRewardList = JSON.parse(JSON.stringify(state.expiredRewardList));
        //     expiredRewardList[action.index].hideDetail = !expiredRewardList[action.index].hideDetail
        //     return {...state,expiredRewardList:expiredRewardList};
        case 'LOG_OUT':
            return state;
        default:
            return state;
    }
}
